/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { useEffect, useState } from 'react'
import { Moon, Sun, Monitor } from 'lucide-react'
import { getTheme, setTheme } from '@/lib/theme'

export default function ThemeToggle() {
  const [theme, _setTheme] = useState<'light'|'dark'|'system'>(() => getTheme())

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const listener = () => getTheme() === 'system' && setTheme('system')
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [])

  const apply = (t: 'light'|'dark'|'system') => {
    _setTheme(t)
    setTheme(t)
  }

  const btn = "px-2 py-1 rounded-xl border border-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-800"

  return (
    <div className="inline-flex items-center gap-2 text-sm">
      <button className={btn + (theme==='light'?' bg-neutral-100 dark:bg-neutral-800':'')} title="Claro" onClick={() => apply('light')}><Sun size={16}/></button>
      <button className={btn + (theme==='dark'?' bg-neutral-100 dark:bg-neutral-800':'')} title="Escuro" onClick={() => apply('dark')}><Moon size={16}/></button>
      <button className={btn + (theme==='system'?' bg-neutral-100 dark:bg-neutral-800':'')} title="Sistema" onClick={() => apply('system')}><Monitor size={16}/></button>
    </div>
  )
}
